import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useWindowWith from "hooks/useWindowWidth";


function CarruselDos({ children }) {
  const [clicked, setClicked] = useState(false);
  const ancho = useWindowWith();
  
  const handleMouseDown = () => {
    setClicked(true);
  };
  const handleMouseUp = () => {
    setClicked(false);
  };

  
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: ancho >= 500 ? (ancho > 768 ? (ancho > 1024 ? (ancho > 1366 ? 4 : 3) : 3) : 2) : 1,
    slidesToScroll: ancho >= 500 ? (ancho > 768 ? (ancho > 1024 ? (ancho > 1366 ? 4 : 3) : 3) : 2) : 1,
    initialSlide: 0,
  };
  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      className={`w-full overflow-hidden ${clicked ? "cursor-grabbing" : "cursor-grab"} pb-5`}
    >
      <Slider {...settings}>
        {children.map((item, index) => {
          return (
            <div key={index} className="p-4 pb-4">
              {item}
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default CarruselDos;
